import { render, staticRenderFns } from "./discoverydetail.vue?vue&type=template&id=1db465cb&"
import script from "./discoverydetail.vue?vue&type=script&lang=ts&"
export * from "./discoverydetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports